'use client';

import { MaskedSvgIcon } from '@/components/help-center/MaskedSvgIcon';
import type { IconRenderMode } from '@/lib/icon-library';
import { cn } from '@/lib/utils';

type IconSvgPreviewProps = {
  svgContent?: string | null;
  url?: string | null;
  renderMode?: IconRenderMode;
  size?: number;
  background?: 'dark' | 'light';
  className?: string;
};

/** Preview seguro: máscara via URL/data, ou img. */
export function IconSvgPreview({
  svgContent,
  url,
  renderMode = 'mask',
  size = 40,
  background = 'dark',
  className,
}: IconSvgPreviewProps) {
  const dataUrl =
    svgContent && svgContent.trim()
      ? `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`
      : null;
  const src = dataUrl || url || null;

  if (!src) {
    return (
      <div
        className={cn(
          'flex items-center justify-center rounded-xl border border-dashed border-white/15 text-[10px] text-slate-500',
          className
        )}
        style={{ width: size, height: size }}
      >
        —
      </div>
    );
  }

  const shell = cn(
    'flex items-center justify-center rounded-xl border',
    background === 'light'
      ? 'border-slate-200 bg-white text-slate-800'
      : 'border-white/10 bg-white/[0.04] text-sky-200',
    className
  );

  if (renderMode === 'img') {
    return (
      <div className={shell} style={{ width: size, height: size }}>
        <img
          src={src}
          alt=""
          className="max-h-[70%] max-w-[70%] object-contain"
          draggable={false}
        />
      </div>
    );
  }

  return (
    <div className={shell} style={{ width: size, height: size }}>
      <MaskedSvgIcon src={src} className="h-[70%] w-[70%]" />
    </div>
  );
}
